<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-fenlei el-icon--left"></i>故障现象
          </div>
          <div class="es-op-box">
            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.equiTypeId"
              placeholder="请选择设备类型"
              clearable
              filterable
              @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.equiTypeId;
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFauAppeList();
                }
              "
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              placeholder="请输故障现象"
              v-model="queryObj.keyWord"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFauAppeList();
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button
              type="primary"
              icon="el-icon-font el-icon-web__tianjia"
              size="mini"
              style="margin-right: 6px"
              @click="add_init"
              >新增</el-button
            >
          </div>
          <el-table
            :data="pageData.list"
            ref="fauAppeTable"
            border
            stripe
            size="mini"
            height="calc(100vh - 250px)"
            style="cursor: pointer"
            highlight-current-row
            @row-click="handleCurrentChange"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="equiTypeName"
              :show-overflow-tooltip="true"
              width="150"
              label="设备类型"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              :show-overflow-tooltip="true"
              label="故障现象"
            >
            </el-table-column>
            <el-table-column
              prop="fauLevelName"
              :show-overflow-tooltip="true"
              label="故障等级"
            >
            </el-table-column>
            <el-table-column
              prop="responseTime"
              :show-overflow-tooltip="true"
              label="规定时长(小时)"
            >
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  title="编辑"
                  @click="edit_init(scope.row)"
                  type="primary"
                  ><i class="el-icon-font el-icon-bianji"></i
                ></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete
                  @del="del(scope.row.id)"
                  :key="scope.row.id"
                  type="icon"
                ></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination
              :data="pageData"
              @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadFauAppeList();
                }
              "
            >
            </es-pagination>
          </div>

          <!--编辑故障现象-->
          <el-dialog
            :visible.sync="editVisible"
            @closed="() => this.$refs['fauAppeForm'].clearValidate()"
            width="500px"
          >
            <span slot="title">
              <i class="el-icon-font el-icon-bianji el-icon--left"></i
              >编辑故障现象
            </span>
            <el-form
              :model="fauAppeInfo"
              :rules="rules"
              size="mini"
              label-position="right"
              label-width="150px"
              ref="fauAppeForm"
            >
              <el-form-item prop="equiTypeId" label="设备类型">
                <el-select
                  ref="typeSelect"
                  style="width: 200px"
                  size="mini"
                  v-model="fauAppeInfo.equiTypeId"
                  placeholder="请选择设备类型"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="name" label="故障现象">
                <el-input
                  v-model="fauAppeInfo.name"
                  placeholder="请输入故障现象"
                  style="width: 200px"
                  :rows="3"
                  type="textarea"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="fauLevelId" label="故障等级">
                <el-select
                  ref="typeSelect"
                  style="width: 200px"
                  size="mini"
                  v-model="fauAppeInfo.fauLevelId"
                  placeholder="请选择故障等级"
                  clearable
                  @change="selectResponseTime"
                  filterable
                >
                  <el-option
                    v-for="item in levels"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="responseTime"
                label="规定时长(小时)"
              >
                <el-input
                  v-model="fauAppeInfo.responseTime"
                  :disabled="true"
                  style="width: 200px"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer">
              <el-button size="mini" @click="editVisible = false"
                >取 消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="submitFauAppe()"
                :loading="saving"
                >保 存</el-button
              >
            </span>
          </el-dialog>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-shebeixinghao el-icon--left"></i
            >故障解决方法【{{ currentRow.name.slice(0, 32) }}】
          </div>

          <div class="es-op-box">
            <el-input
              placeholder="请输故障解决方法"
              v-model="queryObjForFauReso.keyWord"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObjForFauReso.pageNum = 1;
                  loadFauResoList();
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button
              type="primary"
              icon="el-icon-font el-icon-web__tianjia"
              size="mini"
              style="margin-right: 6px"
              :disabled="buttonDisable"
              @click="add_initFauReso"
              >新增</el-button
            >

            <es-delete
              @del="delFauReso()"
              :disabled="buttonDisable"
              type="button"
            ></es-delete>
          </div>
          <el-table
            :data="pageDataForFauReso.list"
            ref="fauResoTable"
            border
            stripe
            size="mini"
            height="calc(100vh - 250px)"
            style="cursor: pointer"
            v-loading="loadingForFauReso"
          >
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="name"
              width="150"
              :show-overflow-tooltip="true"
              label="故障解决方法"
            >
            </el-table-column>
            <el-table-column
              prop="des"
              :show-overflow-tooltip="true"
              label="解决方法描述"
            >
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  title="编辑"
                  @click="edit_initFauReso(scope.row)"
                  type="primary"
                  ><i class="el-icon-font el-icon-bianji"></i
                ></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete
                  @del="delFauReso(scope.row.id)"
                  :key="scope.row.id"
                  type="icon"
                ></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination
              :data="pageDataForFauReso"
              @change="
                (cpage) => {
                  this.queryObjForFauReso.pageNum = cpage;
                  this.loadFauResoList();
                }
              "
            >
            </es-pagination>
          </div>

          <!--编辑故障解决方法-->
          <el-dialog
            :visible.sync="editVisibleForFauReso"
            @closed="() => this.$refs['fauResoForm'].clearValidate()"
            width="500px"
          >
            <span slot="title">
              <i class="el-icon-font el-icon-bianji el-icon--left"></i
              >编辑故障解决方法
            </span>
            <el-form
              :model="fauResoInfo"
              :rules="rulesForFauReso"
              size="mini"
              label-position="right"
              label-width="150px"
              ref="fauResoForm"
            >
              <el-form-item prop="equiTypeId" label="设备类型">
                <el-input
                  v-model="currentRow.equiTypeName"
                  readonly
                  style="width: 200px"
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="appeId" label="故障现象">
                <el-input
                  v-model="currentRow.name"
                  readonly
                  style="width: 200px"
                  :rows="3"
                  type="textarea"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="name" label="故障解决方法">
                <el-input
                  v-model="fauResoInfo.name"
                  placeholder="请输入故障解决方法"
                  style="width: 200px"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="des" label="解决方法描述">
                <el-input
                  v-model="fauResoInfo.des"
                  placeholder="请输入解决方法描述"
                  style="width: 200px"
                  :rows="3"
                  type="textarea"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer">
              <el-button size="mini" @click="editVisibleForFauReso = false"
                >取 消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="submitFauReso()"
                :loading="saving"
                >保 存</el-button
              >
            </span>
          </el-dialog>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "faultappe",
  props: ["funcs"],
  data() {
    return {
      levels: [],
      types: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      buttonDisable: false, //按钮是否可用

      fauAppeInfo: {}, //故障现象信息
      currentRow: { name: "" }, //点击选中的故障现象行

      queryObjForFauReso: { pageNum: 1, pageSize: 20 }, //故障解决方法查询条件
      pageDataForFauReso: {},
      editVisibleForFauReso: false,
      fauResoInfo: {}, //故障解决方法信息

      rules: {
        //验证条件
        name: [
          { required: true, message: "请输入故障现象", trigger: "blur" },
          { max: 50, message: "不能超过50个字符", trigger: "blur" },
        ],
        equiTypeId: [
          { required: true, message: "请选择设备类型", trigger: "blur" },
        ],
        fauLevelId: [
          { required: true, message: "请选择故障等级", trigger: "blur" },
        ],
        standardFaultDuration: [
          { required: true, message: "请输入规定时长", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },

      rulesForFauReso: {
        //验证条件
        name: [
          { required: true, message: "请输入故障解决方法", trigger: "blur" },
          { max: 50, message: "不能超过50个字符", trigger: "blur" },
        ],
        des: [
          { required: false, message: "请输入解决方法描述", trigger: "blur" },
          { max: 500, message: "不能超过500个字符", trigger: "blur" },
        ],
      },
      loading: false,
      saving: false,
      loadingForFauReso: false,
      savingForFauReso: false,
    };
  },
  methods: {
    //页面初始化
    init() {
      this.loadFauAppeList();
      this.loadTypeListAll();
      this.loadLevelListAll();
    },
    //初始化设备类型下拉框
    loadTypeListAll() {
      this.$ajax
        .get("/base/assettype/list_all")
        .then((msg) => {
          this.types = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    selectResponseTime(){
      for (let i = 0, len = this.levels.length; i < len; i++) {
        if (this.levels[i].id == this.fauAppeInfo.fauLevelId) {
          this.fauAppeInfo.responseTime = this.levels[i].responseTime;
          break;
        }
      }
    },
    //初始化故障等级下拉框
    loadLevelListAll() {
      this.$ajax
        .get("/base/faultlevel/list_all")
        .then((msg) => {
          this.levels = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //从后台查询故障现象
    loadFauAppeList() {
      this.loading = true;
      this.buttonDisable = false;

      this.$set(
        this.queryObj,
        "orderBy",
        "a.equi_type_id asc,a.create_time desc"
      );
      this.$ajax
        .get("/base/fauAppe/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;

          if (this.pageData.list.length > 0) {
            this.handleCurrentChange(this.pageData.list[0]);
          } else {
            this.handleCurrentChange(null);
            this.buttonDisable = true;
          }

          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加故障现象
    add_init() {
      this.editVisible = true;
      this.fauAppeInfo = {};
      this.$set(this.fauAppeInfo,"standardFaultDuration",4)
    },
    //初始化编辑故障现象
    edit_init(row) {
      this.editVisible = true;
      this.fauAppeInfo = JSON.parse(JSON.stringify(row));
    },
    //保存故障现象
    submitFauAppe() {
      this.$refs["fauAppeForm"].validate((valid) => {
        if (valid) {
          let url = "/base/fauAppe/add";
          if (this.fauAppeInfo.id != null) {
            url = "/base/fauAppe/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.fauAppeInfo)
            .then((msg) => {
              this.saving = false;
              this.loadFauAppeList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除故障现象
    del(delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["fauAppeTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/base/fauAppe/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadFauAppeList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },

    //从后台查询故障解决方法
    loadFauResoList() {
      this.loadingForFauReso = true;

      this.$ajax
        .get("/base/fauAppe/listFauReso", this.queryObjForFauReso)
        .then((msg) => {
          this.pageDataForFauReso = msg;
          this.loadingForFauReso = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loadingForFauReso = false;
        });
    },

    //初始化添加故障解决方法
    add_initFauReso() {
      this.editVisibleForFauReso = true;
      this.fauResoInfo = {};
    },

    //初始化编辑故障解决方法
    edit_initFauReso(row) {
      this.editVisibleForFauReso = true;
      this.fauResoInfo = JSON.parse(JSON.stringify(row));
    },
    //保存故障解决方法
    submitFauReso() {
      this.$refs["fauResoForm"].validate((valid) => {
        if (valid) {
          let url = "/base/fauAppe/addFauReso";
          if (this.fauResoInfo.id != null) {
            url = "/base/fauAppe/editFauReso";
          }
          this.saving = true;
          this.fauResoInfo.appeId = this.currentRow.id;
          this.$ajax
            .post(url, this.fauResoInfo)
            .then((msg) => {
              this.saving = false;
              this.queryObjForFauReso.appeId = this.currentRow.id; //保存之后，显示当前选中的故障现象
              this.loadFauResoList();
              this.editVisibleForFauReso = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除故障解决方法
    delFauReso(delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["fauResoTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loadingForFauReso = true;
        this.$ajax
          .post("/base/fauAppe/deleteFauReso", { ids: ids })
          .then((msg) => {
            this.loadingForFauReso = false;
            this.$message.success(msg);
            this.queryObjForFauReso.pageNum = 1; //删除之后，回到第一页
            this.queryObjForFauReso.appeId = this.currentRow.id; //删除之后，显示当前选中的故障现象
            this.loadFauResoList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loadingForFauReso = false;
          });
      }
    },
    //点击表格行触发事件
    handleCurrentChange(row) {
      if (row != null) {
        this.currentRow = JSON.parse(JSON.stringify(row));
        this.queryObjForFauReso.appeId = this.currentRow.id;
        this.$refs.fauAppeTable.setCurrentRow(row);
      } else {
        this.currentRow.name = "";
        this.queryObjForFauReso.appeId = 0;
      }

      this.loadFauResoList();
    },
    handleChange(value) {
      console.log(value);
    },
    stateFormat(row) {
      if (row.state == 1) {
        row.statename = "启用";
        return "success";
      } else {
        row.statename = "停用";
        return "danger";
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
</style>
